/* Inner pages share one mobile frame and one top owner. */
(() => {
  const mobile = matchMedia('(max-width: 1200px)');
  let scrollFrame = 0;
  let topAnchor = null;
  let topPlaceholder = null;
  function placeMenuInFrame() {
    topAnchor = document.querySelector('.ak-menu-sticky-anchor') || topAnchor;
    if (!topAnchor) return;
    if (mobile.matches && document.body.classList.contains('ak-page-inner')) {
      if (!topPlaceholder && topAnchor.closest('#MainContent')) {
        topPlaceholder = document.createComment('Mobile frame top: desktop menu position');
        topAnchor.before(topPlaceholder);
      }
      // Safari clips fixed descendants of the native scrolling main. The
      // frame top belongs beside that scroller, just like the logo fallback.
      if (topPlaceholder && topAnchor.parentElement !== document.body) document.body.append(topAnchor);
    } else if (topPlaceholder?.parentNode) {
      topPlaceholder.replaceWith(topAnchor);
      topPlaceholder = null;
    }
  }
  let stickyCandidates = null;
  function syncStickySeams() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    if (!mobile.matches) {
      main.querySelectorAll('[data-ak-sticky-seam]').forEach(element => element.removeAttribute('data-ak-sticky-seam'));
      stickyCandidates = null;
      return;
    }
    // Read first, then write once. Every sticky using the top of this scrollport
    // shares the fixed header's painted row, including future section headings.
    if (!stickyCandidates) stickyCandidates = Array.from(main.querySelectorAll('*')).filter(element => {
      const style = getComputedStyle(element);
      const top = parseFloat(style.top);
      return style.position === 'sticky' && top >= -1 && top <= 1;
    });
    stickyCandidates.forEach(element => element.setAttribute('data-ak-sticky-seam','top'));
  }
  function sync() {
    if (window.AK_NATIVE_ZOOM?.isZooming()) return;
    placeMenuInFrame();
    syncStickySeams();
    if (!mobile.matches) return;
    const body = document.body;
    const single = document.querySelector('[data-ak-frame-top="single-level"]');
    body.classList.toggle('ak-inner-single-top', Boolean(single));
    body.classList.toggle('ak-inner-brand-top', !single);
    document.querySelectorAll('[data-ak-frame-top="brand"]:not([data-ak-inner-brand])').forEach(top => {
      const section = top.closest('#MainContent > .shopify-section');
      if (!section) return;
      const copy = section.cloneNode(true);
      copy.querySelectorAll('[data-ak-frame-top="brand"],script,style').forEach(node => node.remove());
      if (!copy.textContent.trim() && !copy.querySelector('img,video,form,iframe')) section.dataset.akLegacyFrameTop = 'true';
    });
    const main = document.getElementById('MainContent');
    if (main) {
      const topSpace = parseFloat(getComputedStyle(main).paddingTop) || 0;
      main.style.setProperty('--ak-inner-content-height', Math.max(0, main.clientHeight - topSpace - 45) + 'px');
      const contact = main.querySelector('.ak-contact-page');
      const end = contact?.querySelector('.ak-contact-horizontal-line-8');
      if (end) {
        contact.style.setProperty('--ak-contact-row-submit', '56px');
        // Layout offsets exclude the entrance transforms on the frame cells.
        const line = main.offsetTop + contact.offsetTop + end.offsetTop;
        const rail = document.querySelector('.ak-site-frame-rail--left');
        if (!rail) return;
        const strokes = [...rail.querySelectorAll('.ak-site-frame-rail__grid')].flatMap(grid =>
          Array.from({length:13}, (_, row) => rail.offsetTop + grid.offsetTop + row * grid.offsetHeight / 12 - 1));
        const target = strokes.reduce((best, stroke) => Math.abs(stroke - line) < Math.abs(best - line) ? stroke : best, Infinity);
        // Preserve the form layout; close only a small gap to the side grid.
        if (Math.abs(target - line) <= 4) contact.style.setProperty('--ak-contact-row-submit', `${56 + target - line}px`);
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once:true});
  else sync();
  document.getElementById('MainContent')?.addEventListener('scroll', () => {
    if (!mobile.matches || document.body.classList.contains('ak-page-product') || scrollFrame) return;
    scrollFrame = requestAnimationFrame(() => {
      scrollFrame = 0;
      // Existing section reveals still listen to the window scroll event.
      window.dispatchEvent(new Event('scroll'));
    });
  }, {passive:true});
  mobile.addEventListener('change', sync);
  window.addEventListener('resize', sync, {passive:true});
  window.addEventListener('ak:mobile-resume', sync);
  function rescanStickySeams() { stickyCandidates = null; sync(); }
  document.addEventListener('shopify:section:load', rescanStickySeams);
  window.addEventListener('ak:global-frame-ready', rescanStickySeams);
  window.addEventListener('ak:boot-revealed', rescanStickySeams);
  window.addEventListener('pageshow', sync);
})();
